import styled from '@emotion/styled';

export default function TypeButtonSkeleton() {
  return <Container />;
}

const Container = styled.div`
  width: 80px;
  height: 30px;
  border-radius: 16px;
  background: ${({ theme }) => theme.backgroundColor.bg_dark_2};
`;
